// extracted by mini-css-extract-plugin
module.exports = {"item":"style-module--item--2x5o3","name":"style-module--name--1hY7H","spec":"style-module--spec--1v9NN","container":"style-module--container--ZZuaV"};